import axios from 'axios';
import api, { NEXTJS_API_URL } from './client';

export const clabApplicationAPI = {
  getAllApplications: async (params = {}) => {
    try {
      const response = await axios.get(
        `${NEXTJS_API_URL}/clab/selection-requests`,
        {
          params,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      return {
        status: "success",
        data: response.data,
      };
    } catch (error) {
      console.error("Error fetching CLAB selection requests:", error);
      return {
        status: "error",
        message:
          error.response?.data?.error ||
          error.message ||
          "Failed to load selection requests",
        data: { data: [], pagination: null },
      };
    }
  },

  getPendingApplications: async (params = {}) => {
    try {
      // Use same endpoint as other tabs (selection-requests) for consistency
      const response = await axios.get(
        `${NEXTJS_API_URL}/clab/selection-requests`,
        {
          params,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      // Handle Next.js Laravel-format response
      if (response.data.status === "success" || response.data.data) {
        return {
          status: "success",
          data: response.data,
        };
      } else {
        return {
          status: "error",
          data: [],
          message:
            response.data.message || "Failed to load pending applications",
        };
      }
    } catch (error) {
      console.error("Error fetching pending applications:", error);
      return {
        status: "error",
        data: [],
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to load pending applications",
      };
    }
  },

  approveApplication: async (id) => {
    const response = await api.post(`/clab/applications/${id}/approve`);
    return response.data;
  },

  rejectApplication: async (id, rejectData) => {
    const response = await api.post(
      `/clab/applications/${id}/reject`,
      rejectData
    );
    return response.data;
  },

  rejectApplicationWorker: async (id, rejectData) => {
    const response = await api.post(
      `/clab/application-workers/${id}/reject`,
      rejectData
    );
    return response.data;
  },

  returnWorkerToPool: async (id) => {
    const response = await api.post(
      `/clab/application-workers/${id}/return-to-pool`
    );
    return response.data;
  },

  approveApplicationWorker: async (
    applicationId,
    workerId,
    approveData = {}
  ) => {
    // Get current user for approvedBy field
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const payload = {
      approvedBy: user.id,
      ...approveData,
    };
    const response = await api.post(
      `/clab/applications/${applicationId}/workers/${workerId}/approve`,
      payload
    );
    return response.data;
  },

  approveAllWorkers: async (applicationId) => {
    const response = await api.post(
      `/clab/applications/${applicationId}/approve-all`
    );
    return response.data;
  },

  rejectApplicationWorkerNew: async (applicationId, workerId, rejectData) => {
    // Get current user for rejectedBy field
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const reasonId = rejectData.rejectionReasonId || rejectData.reason_id;
    const payload = {
      rejectedBy: user.id,
      rejectionReasonId: reasonId ? Number(reasonId) : undefined,
      comments: rejectData.comments || rejectData.remarks,
      ...rejectData,
      reason_id: reasonId ? Number(reasonId) : undefined,
    };
    const response = await api.post(
      `/clab/applications/${applicationId}/workers/${workerId}/reject`,
      payload
    );
    return response.data;
  },

  getApplicationDetails: async (id) => {
    const response = await api.get(`/clab/selection-requests/${id}`);
    return response.data;
  },
};

// Notification API

export const applicationWorkerAPI = {
  getAll: async (applicationId) => {
    const response = await api.get(`/applications/${applicationId}/workers`);
    return response.data;
  },
  add: async (applicationId, data) => {
    const response = await api.post(
      `/applications/${applicationId}/workers`,
      data
    );
    return response.data;
  },
  batchAdd: async (applicationId, data) => {
    const response = await api.post(
      `/applications/${applicationId}/workers/batch`,
      data
    );
    return response.data;
  },
  batchUpdate: async (applicationId, data) => {
    const response = await api.post(
      `/applications/${applicationId}/workers/batch-update`,
      data
    );
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/application-workers/${id}`);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/application-workers/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/application-workers/${id}`);
    return response.data;
  },
  returnToPool: async (id, data) => {
    const response = await api.post(`/application-workers/${id}/return`, data);
    return response.data;
  },
  replaceWorker: async (applicationId, currentWorkerId, newWorkerId) => {
    const response = await api.post(
      `/applications/${applicationId}/workers/${currentWorkerId}/replace`,
      {
        new_worker_id: newWorkerId,
      }
    );
    return response.data;
  },
  getAvailableWorkers: async (filters = {}) => {
    const response = await api.get("/workers/available", { params: filters });
    return response.data;
  },
};

// Settings API
